import {useSelector} from 'react-redux';

import useIsNavigationBarVisible, {useIsNavigationBarRoute} from '../../hooks/useIsNavigationBarVisible';
import {selectIsPWA} from '../../state/selectors/global';
import {twx} from '../../utils/tailwindUtils';
import AiAssistantButton from '../AiAssistant/AiAssistantButton';
import NAVIGATION_BAR_CONFIG from './navigationBarConfig';
import {PWA_BOTTOM_PADDING_PX, WEB_BOTTOM_PADDING_PX} from './navigationBarConstants';
import NavigationBarItem from './NavigationBarItem';

const NavigationBar = () => {
    const isNavigationBarRoute = useIsNavigationBarRoute();
    const isNavigationBarVisible = useIsNavigationBarVisible();
    const isPWA = useSelector(selectIsPWA);

    if (!isNavigationBarRoute) return null;

    return (
        <div
            className={twx(
                'fixed bottom-0 left-1/2 z-[120] flex w-full max-w-md -translate-x-1/2 items-center gap-2 overflow-hidden border-t border-[#7B787F] bg-color-romance px-2 transition-[transform,opacity] duration-300 ease-in-out will-change-transform dark:bg-color-slate-gray',
                !isNavigationBarVisible && 'pointer-events-none translate-y-full opacity-0'
            )}
            style={{
                paddingBottom: isPWA ? PWA_BOTTOM_PADDING_PX : WEB_BOTTOM_PADDING_PX,
            }}
        >
            {NAVIGATION_BAR_CONFIG.map((data, index) => (
                <NavigationBarItem key={index} {...data} />
            ))}

            <AiAssistantButton />
        </div>
    );
};

export default NavigationBar;
